import React, { useEffect, useState } from "react";

// TODO操作カード（ホーム／TODOボード共通）。
// 状態はアクションボタンで示す：未対応=「対応する」/ 対応中=「完了」/ 完了=「完了取消」。
// 右上＝編集/削除、カードクリックでメモ（コメント）開閉。
// 開閉・編集中の判定は親が保持する（isOpen/isEditing）＝同時に開くのは1枚。入力の一時値はカード内で保持。

// 本人を表すセンチネル。モックではなくサーバとの契約：
// views_employee_todo.py が assignee とメモの by を「本人のものだけ "自分" に変換」して返すため、
// フロントはログインユーザーのIDを知らなくても本人判定ができる。
// （メモ削除ボタンの出し分けにも使うが、権限自体は BE が by_id で 403 判定する。）
const ME = "自分";

// 状態ごとのアクション（ボタン表示＋押下後の遷移先＋通知文）。親の advance がこれを参照する。
const ACTION = {
  open: { label: "対応する", cls: "mp-primary", next: "doing", msg: "あなたが担当になりました" },
  doing: { label: "完了", cls: "mp-ghost", next: "done", msg: "完了にしました" },
  done: { label: "完了取消", cls: "mp-ghost", next: "doing", msg: "完了を取り消しました" },
};

// "2026-07-03" → "07/03"（表示用）
const fmtDue = (iso) => {
  if (!iso) return null;
  const m = /^\d{4}-(\d{2})-(\d{2})$/.exec(iso);
  return m ? `${m[1]}/${m[2]}` : iso;
};

// アイコンは絵文字を使わずSVGで統一。
const MemoIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5.5h16v11H10l-4 3v-3H4z" strokeLinejoin="round" /><path d="M8 9.5h8M8 12.5h5" strokeLinecap="round" /></svg>
);
const EditIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 19h14M6 15l9-9 3 3-9 9-3.6.6z" strokeLinejoin="round" /></svg>
);
const TrashIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13" strokeLinecap="round" strokeLinejoin="round" /></svg>
);
const CalIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="5.5" width="16" height="14" rx="2" /><path d="M4 9.5h16M8 3.5v3M16 3.5v3" strokeLinecap="round" /></svg>
);

// 1枚のカード。todo と操作コールバックを受け取る。編集/メモの入力一時値はカード内で持つ。
function TodoCard({
  todo,
  isOpen,
  isEditing,
  onToggleMemo,
  onAdvance,
  onStartEdit,
  onCancelEdit,
  onSaveEdit,
  onDelete,
  onAddMemo,
  onDeleteMemo,
}) {
  const [editTitle, setEditTitle] = useState(todo.title);
  const [editDue, setEditDue] = useState(todo.due || "");
  const [draft, setDraft] = useState("");

  // 編集開始時に現在値をフォームへ流し込む。
  useEffect(() => { if (isEditing) { setEditTitle(todo.title); setEditDue(todo.due || ""); } }, [isEditing, todo.title, todo.due]);
  // カードを閉じたらメモ下書きは破棄。
  useEffect(() => { if (!isOpen) setDraft(""); }, [isOpen]);

  const t = todo;
  const mine = t.assignee === ME;

  // 編集モード：件名＋締切＋（保存／キャンセル）。
  if (isEditing) {
    const save = () => {
      const title = editTitle.trim();
      if (!title) { onCancelEdit(); return; } // 件名が空なら破棄して閉じる
      onSaveEdit(t.id, title, editDue || null);
    };
    return (
      <div className="mp-todo-card mp-todo-editcard">
        <div className="mp-todo-efield">
          <label className="mp-todo-elabel">件名</label>
          <input
            className="mp-input"
            value={editTitle}
            autoFocus
            placeholder="タスク内容"
            onChange={(e) => setEditTitle(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") onCancelEdit(); }}
          />
        </div>
        <div className="mp-todo-efield">
          <label className="mp-todo-elabel">締切</label>
          <input className="mp-input" type="date" value={editDue} onChange={(e) => setEditDue(e.target.value)} />
        </div>
        <div className="mp-todo-ebtns">
          <button className="mp-btn mp-primary" onClick={save}>保存</button>
          <button className="mp-btn mp-ghost" onClick={onCancelEdit}>キャンセル</button>
        </div>
      </div>
    );
  }

  const action = ACTION[t.status];
  const memos = t.memos || [];
  return (
    <div
      className={`mp-todo-card${t.status === "done" ? " mp-todo-card-done" : ""}`}
      onClick={() => onToggleMemo(t.id)}
    >
      {/* 上段：件名＋右上に編集/削除。削除は編集モードに入らず直接できる。 */}
      <div className="mp-todo-cardhead">
        <span className="mp-todo-title">{t.title}</span>
        <button className="mp-todo-ic" aria-label="内容を編集" onClick={(e) => { e.stopPropagation(); onStartEdit(t); }}><EditIcon /></button>
        <button className="mp-todo-ic mp-todo-ic-danger" aria-label="削除" onClick={(e) => { e.stopPropagation(); onDelete(t); }}><TrashIcon /></button>
      </div>

      {/* 締切（未設定は薄く「締切なし」）＋担当 */}
      <div className="mp-todo-meta">
        {t.due
          ? <span className="mp-todo-due"><CalIcon /> 締切 {fmtDue(t.due)}</span>
          : <span className="mp-todo-due mp-todo-due-none"><CalIcon /> 締切なし</span>}
        {t.assignee
          ? <span className="mp-todo-assignee">担当 <b>{mine ? "あなた" : t.assignee}</b></span>
          : <span className="mp-muted">担当者なし</span>}
      </div>

      {/* メモの件数表示（カードクリックで開閉） */}
      <div className="mp-todo-memorow">
        <span className="mp-todo-memo-ind"><MemoIcon /> メモ{memos.length > 0 ? ` ${memos.length}` : ""}</span>
      </div>

      {/* 状態のアクションボタン（対応する / 完了 / 完了取消） */}
      <button className={`mp-btn ${action.cls} mp-todo-act`} onClick={(e) => { e.stopPropagation(); onAdvance(t); }}>{action.label}</button>

      {/* メモ（アコーディオン）。パネル内クリックでカードが閉じないよう伝播を止める。 */}
      {isOpen && (
        <div className="mp-todo-memopanel" onClick={(e) => e.stopPropagation()}>
          {memos.length > 0 && (
            <div className="mp-memo-list">
              {memos.map((m, i) => (
                <div className="mp-memo-item" key={i}>
                  <div className="mp-memo-head">
                    <b>{m.by === ME ? "あなた" : m.by}</b>
                    <span>{m.at}</span>
                    {/* 削除は添字ではなく mid（メモの安定ID）で指定する。TODOは全社共有で、
                        他の人が先にメモを消すと添字がずれ、自分の別のメモが黙って消えるため
                        （by_id チェックは自分のメモである限り通ってしまい防げない）。 */}
                    {m.by === ME && (
                      <button className="mp-memo-del" aria-label="メモを削除" onClick={() => onDeleteMemo(t.id, m.mid)}>×</button>
                    )}
                  </div>
                  <div className="mp-memo-text">{m.text}</div>
                </div>
              ))}
            </div>
          )}
          <div className="mp-memo-add">
            <input
              className="mp-input"
              placeholder="メモを追加（例：〇〇に確認済み）"
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") { onAddMemo(t.id, draft); setDraft(""); } }}
            />
            <button className="mp-btn mp-primary mp-sm" onClick={() => { onAddMemo(t.id, draft); setDraft(""); }}>追加</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default TodoCard;
export { ACTION, fmtDue, ME };
